import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const handleCTAClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Track AddToCart event
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Quincena Milagrosa',
        content_ids: ['42994498404470'],
        content_type: 'product',
        value: 7.97,
        currency: 'USD'
      });
    }
  };
  return <section className="relative bg-[#FFFBEB] overflow-hidden" data-id="element-98">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-amber-200/30 via-transparent to-transparent" data-id="element-99" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 relative z-10" data-id="element-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-101">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="space-y-8" data-id="element-102">
            <div className="space-y-4" data-id="element-103">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-amber-950 leading-tight" data-id="element-104">
                Si cada quincena empieza con{' '}
                <span className="text-amber-600" data-id="element-105">esperanza</span>…
              </h1>
              <h2 className="text-3xl md:text-4xl font-serif italic text-amber-800" data-id="element-106">
                y termina con ansiedad…
              </h2>
            </div>

            <div className="prose prose-lg text-amber-900/80 space-y-4" data-id="element-107">
              <p className="font-medium text-xl border-l-4 border-amber-500 pl-4" data-id="element-108">
                Déjame decirte algo antes de que sigas leyendo: <br data-id="element-109" />
                <span className="font-bold text-amber-950" data-id="element-110">
                  no estás fallando tú.
                </span>
              </p>

              <p data-id="element-111">
                Cobras. Respiras. Te dices: "Ahora sí me organizo." Pero pasan
                los días… y el dinero se evapora. No en una compra grande. No en
                una locura. Se va en silencio.
              </p>

              <p data-id="element-112">
                Y cuando te das cuenta… ya estás otra vez contando pesos,
                calculando mentalmente, postergando cosas, sintiéndote mal
                contigo misma por no haberlo hecho "mejor".
              </p>
            </div>

            <div className="pt-4" data-id="element-113">
              <a href="https://almadigitalebooks.digital/cart/42994498404470:1" onClick={handleCTAClick} className="w-full sm:w-auto bg-gradient-to-r from-amber-600 to-orange-600 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-xl shadow-amber-900/20 hover:shadow-2xl hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-114">
                <span data-id="element-115">Accede ahora a Quincena Milagrosa</span>
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-116" />
              </a>
              <p className="text-sm text-amber-800/60 mt-3 text-center sm:text-left" data-id="element-117">
                Pago único $7.97 USD · Acceso inmediato · Incluye 3 bonos
              </p>
            </div>
          </motion.div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-118">
            <div className="absolute -inset-4 bg-amber-200/50 rounded-[2rem] blur-2xl -z-10" data-id="element-119" />
            <img src="https://cdn.magicpatterns.com/uploads/65m9ej2jgvZBoYufD8ap6k/ChatGPT_Image_Jan_21,_2026,_08_38_08_PM.png" alt="Mujer tranquila leyendo en su tablet" className="rounded-[2rem] shadow-2xl w-full object-cover transform rotate-1 hover:rotate-0 transition-transform duration-500" data-id="element-120" />

            {/* Floating Badge */}
            <motion.div initial={{
            y: 20,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            delay: 0.8
          }} className="absolute -bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-amber-100 max-w-xs hidden md:block" data-id="element-121">
              <p className="font-serif italic text-amber-900 text-lg" data-id="element-122">
                "El problema no es que ganes poco. El problema es que nadie te
                enseñó a manejar la quincena."
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}